const config = {
  basename: "",
  defaultPath: "/licenses",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12
};

export default config;
